import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import CandidateCard from 'components/CandidateCard'
import InfoLayer from 'components/InfoLayer'
import Candidate from 'Types/candidate.interface'
import { device } from '../breakpoints'

type CandidatesListProps = {
  candidates: Candidate[]
}

const CandidatesList: FC<CandidatesListProps> = ({
  candidates
}): ReactElement => {
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null>()

  return (
    <Container>
      {selectedCandidate && (
        <InfoLayer
          handleClose={() => setSelectedCandidate(null)}
          handleNextCandidateClick={(nextCandidate:Candidate) => {setSelectedCandidate(nextCandidate)}}
          candidate={selectedCandidate}
          nextCandidate={
            candidates[
              (candidates.findIndex((c) => c.id === selectedCandidate.id) + 1) %
                candidates.length
            ]
          }
        />
      )}
      <ListContainer>
        <Content>
          {candidates.map((candidate) => (
            <CandidateCard
              key={`candidate-${candidate.id}`}
              candidate={candidate}
              handleSelectCandidate={setSelectedCandidate}
            />
          ))}
        </Content>
      </ListContainer>
    </Container>
  )
}
const Container = styled.div`
  position: relative;
  margin-bottom: 4rem;
`

const ListContainer = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 1rem;
`

const Content = styled.div`
  display: grid;
  font-family: TamediaChart;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
`

export default CandidatesList
